import { render, staticRenderFns } from "./SurveyRatingItem.vue?vue&type=template&id=9fe73522&"
import script from "./SurveyRatingItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyRatingItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports